<template>
    <div class="social-follow-wrap">
        <h3 class="title-with-dot">Follow Me</h3>

        <ul>
            <li>
                <a href="https://instagram.com"><i class="lab la-instagram"></i></a>
            </li>
            <li>
                <a href="https://dribbble.com"><i class="lab la-dribbble"></i></a>
            </li>
            <li>
                <a href="https://linkedin.com"><i class="lab la-linkedin-in"></i></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'SocialFollow'
}
</script>